// extracted by mini-css-extract-plugin
export default {"wrapper":"Receivables_wrapper__nGZFO","sidebarWrapper":"Receivables_sidebarWrapper__C4XO0","sectionWrapper":"Receivables_sectionWrapper__VZ70x"};